import axios from "axios";
import { ElMessage } from 'element-plus'
import * as Utils from './utils'
import mokeData from "../../mock/index.ts";
// import data from "../../mock/index.ts";

export const baseURL = '/api/v1/admin'
// 静态资源静态资源前缀
export const staticPrefix = (window.location.host.indexOf('localhost') > -1 || window.location.host.indexOf('127.0.0.1') > -1) ? 'https://h88agent-1347440491.cos.ap-shanghai.myqcloud.com/': 'https://h88agent.zhuangyum.com/'

// 是否使用mock数据
export const useMock = false

export const request = (options = {}) => {
  const { url, data, method } = options;

  const instance = axios.create({
    baseURL,
    withCredentials: true,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    timeout: 5000
  });
  instance.interceptors.request.use(config => {
    config.headers['Access-Control-Allow-Origin'] = '*';

    const token = Utils.user.getToken();
    if (token) {
      config.headers['Authorization'] = token;
    }

    return config
  });
  instance.interceptors.response.use(
    (res) => {
      if (res?.data?.status === 200) {
        return Promise.resolve(res.data)
      } else {
        if(res?.data?.msg) {
          ElMessage.error(res?.data?.msg)
        }
        return Promise.resolve(res.data)
      }
    },
    (err) => {
      if (err?.response?.status === 401) {
        console.error('401')
        //未登录或登录过期
        Utils.user.logout();
        window.location.href = '/login';
        return;
      }

      console.error('err', err.message);
      return Promise.reject(err);
    }
  );

  return instance({ url, data, method });
};

export const post = (options = {}, hideErr = false) => {
  if (useMock == true) {
    return {
      status: 200,
      data: mokeData[options.url] || {}
    }
  }
  return request({
    ...options,
    method: 'post'
  }).catch(err => {
    console.log('err', err)
    if(!hideErr) {
      ElMessage.error(err)
      return false;
    }
    return { error: err }
  });
};

export const del = (options = {}) => {
  if (useMock == true) {
    return {
      status: 200,
      data: mokeData[options.url] || {}
    }
  }
  return request({
    ...options,
    method: 'delete'
  });
};


export const get = (options = {}) => {
  if (useMock == true) {
    return {
      status: 200,
      data: mokeData[options.url] || {}
    }
  }
  console.log(options, 'options-----');
  const datas = []
  for(let i in options.data) {
    datas.push(`${i}=${options.data[i]}`)
  }
  if(datas.length > 0) {
    options.url = options.url + '?' + datas.join('&');
  }
  return request({
    ...options,
    method: 'get'
  });
};
